export default {
  home: '平台首页',
  adminTitle: '品牌商后台',
  zh_CN: '中文',
  en_US: '英文',
  CN: '中文',
  EN: '英文',
  save: '保存',
  cancel: '取消',
  reset: "重置",
  add: "新增",
  confirm: '确定',
  search: '搜索',
  detail: '详情',
  upload: '上传',
  delete: '删除',
  edit: '编辑',
  multiLanguage: '多语言',
  inputPlaceholder: '请输入',
  selectPlaceholder: '请选择',
  selectloadingPlaceholder: '加载中',
  yes: '是',
  no: '否',
  update: '更新',
  OperationFailed: '操作失败',
  AcquisitionFailed: '获取失败',
  set: '设置',
  logout: '退出登录',
  changepwd: '修改密码',
  resetpwd: '重置密码',
  success: '操作成功',
  failed: '操作失败',
  required: '必填项不能为空',
  nodata: '暂无数据',
  legend: '图例',
  Registeredusers: '注册数',
  RecordNo: "苏ICP备19056288号",
  copyright: "©2021-现在 hyecosmart.com 版权所有",
  All: '所有',
  upError: {
    formatError: '文件格式错误',
    pleaseSele: '请选择',
    file: '文件',
    type: '类型',
    name: '名称格式错误'
  },
  img: {
    success: '上传成功',
    failed: '上传失败',
  },
  ruleCustom: {
    pwd: '请输入大小写字母和数字的组合，长度在6-20之间',
    email: '邮箱格式不正确',
    phone: '手机号码格式不正确',
    vercode: '验证码必须填写',
    positive_integer: '请输入正整数',
    non_negative_integer: '请输入非负整数',
    16: "请输入16进制格式，以0x开头",
    '0x3f': "0x00~0x3f",
    productType: '禁止输入中文',
    basicName: "请输入 由字母、数字、下划线、中划线或空格组成的字符串",
    format: '格式错误',
    pageId: '请输入数字格式的字符串',
    l100: '字数不能大于100',
    l50: '字数不能大于50',
    fixedTelephone: '国家码，以“+”开头,1到3位数字；区号，2到3位数字，不以“0”开头；号码,7到8位数字；例如+86 11 1234567',
    wordCode: '支持大小写字母、数字和下划线,不超过 50 个字符。',
    UIcode: '支持大小写字母、数字和下划线,不超过 36 个字符。',
    blankCode: '请输入非空字符串或者空白字符',
    httpLink:'请输入有效的网页链接,必须以 http:// 或 https:// 开头。'
  },
  successInfo: {
    sync: '同步成功'
  },
  errorInfo: {
    sync: '同步失败'
  },
  selectList: {
    MessageStatus: {
      New: '新消息',
      Read: '已读',
      Reply: '已回复',
    },
    functionCategoryList: {
      'Water_equipment': '滴灌设备',
      'Raingauge': '雨量器',
      'Flowgauge': '流量器',
      'Soil_moisture_detector': '土壤干湿度器'
    },
    connectionTypeList: {
      'BLE': '蓝牙',
      'BLEMesh': '蓝牙Mesh',
      'BLE5': '蓝牙5.0',
      'WIFI': 'WIFI',
      'LORADTU': 'LORADTU',
      'LORAWan': 'LORAWan',
    },
    standardTypeList: {
      'Yes': '是',
      'No': '否'
    },
    StatusList: {
      'Test': '测试',
      'Big_sale': '热卖',
      'Stop_sale': '停止出售'
    },
    deviceStatus: {
      Free: '未激活',
      Activate: '已激活',
      Return: '解绑',
    },
    onlineType: {
      Online: '在线',
      Outline: '离线',
      Disabled: '禁用'
    },
    releaseTypeList: {
      beta: '测试版',
      release: '正式版',
    },
    appStatusList: {
      'Online': '在使用',
      'Expired': '已过期',
    },
    comModeListBasic: {
      'BLE': '蓝牙',
      'WIFI': 'WIFI',
      'LORADTU': 'LORADTU',
      'LORAWan': 'LORAWan',
      'BLEMesh': '蓝牙Mesh',
      'BLE5': '蓝牙5.0',
      '4GCat1': '4G cat1',
      'RS485': 'RS485',
      '4G': '4G',
      'other': '其他/不详',
    },
    connectListBasic: {
      'Not_networked': '不联网',
      'Gateway': '网关',
      'Gateway_device': '网关下设备',
      'direct-connected_facility': '直连设备',
      'base_station': '基站',
      'base_station_facility': '基站下设备',
    },
    smDeviceTypeBasic: {
      'Main_equipment': '主设备',
      'Rain_gauge': '辅助设备雨量计',
      'Valve_flowmeter': '辅助设备阀门流量计',
      'Soil_hygrometer': '辅助设备土壤干湿计',
    },
    loraProductKeyBasic: {
      'A6k_t3Rng': 'LoRaWan classA',
      'u_ElpqR7R': 'LoRaWan classB',
      'HJTutqgnR': 'LoRaWan classC',
      'aYFrpqg7g': 'LoRaWan 基站',
      'None': 'None'
    },
    RWlist: {
      'R': '只读',
      'RW': '读写'
    },
    MustedList: {
      'true': '是',
      'false': '否'
    },
    designImplTypeList: {
      'type1': 'BLE同步配置',
      'type2': '二进制KLV',
      'type3': 'HyECO平台JSON',
      'type4': 'Aqube平台JSON',
      'type5': 'WIFI同步配置',
    },
    subdeviceTypeList: {
      'LORAWAN': 'LoRaWan子设备',
      'LORAWAN_A': 'LoRaWan classA 子设备',
      'LORAWAN_B': 'LoRaWan classB 子设备',
      'LORAWAN_C': 'LoRaWan classC 子设备',
      'LORADTU': 'LoRaDTU子设备',
      'MODBUS': '通用485子设备',
      'HYBUS': '私有485子设备',
    },
    communicateProtocolList: {
      'type1': '二进制KLV协议V1版',
      'type2': '多路滴灌专用协议V1版',
      'type3': '字符KV协议V1版',
      'type4': '其它/无协议',
      'type5': 'hyecosmart的json协议',
    },
    joinSenseList: {
      'true': '可以',
      'false': '不可以',
      'type1': '只可当条件',
      'type2': '只可被执行',
      'type3': '都不可以',
      'type4': '都可以 ',
    },
    timeUnit: {
      'year': '年(year)',
      'month': '月(month)',
      'day': '日(day)',
      'hour': '时(h)',
      'minute': '分(min)',
      'second': '秒(s)',
      'msceond': '毫秒(ms)'
    },
    transactionType: {
      "Recharge": "充值",
      "SMS": "短信扣费",
      "other": "其他费用，一次性扣费",
      "Activate": "激活设备扣费"
    },
    whetherRun: {
      "Running": "运行",
      "Stoped": "停止"
    }
  },
  loginPage: {
    userName: '用户名',
    password: '密码',
    VerificationCode: '验证码',
    RememberPassword: '记住密码',
    ForgetPassword: '忘记密码',
    Signin: '登录',
    forget: {
      title: '身份校验',
      stitle: '请输入重置密码的邮箱账号',
      email: "用户邮箱",
      code: "验证码",
    },
    reset: {
      title: '设置新密码'
    }
  },
  topCon: {
    CurrentPassword: '旧密码',
    NewPassword: '新密码',
    NewPassword1: '确认新密码',
    confirmOut: '确认退出登录？',
    colseLeft: '关闭左侧',
    colseRight: '关闭右侧',
    colseOther: '关闭其他',
    dealerInfoErr: '请在设置页面完善资料信息'
  },
  homePage: {
    Products: '产品',
    Market: '上市数量',
    User: '用户',
    Total: '总用户数',
    Online: '在线人数',
    Device: '设备',
    Active: '激活量',
    Online1: '在线数量',
    App: 'APP',
    LastAndroidVer: '最新Android版本',
    LastAppleVer: '最新ios版本',
    Messages: '消息',
    New: '新消息',
    Push: '推送',
    PushOfTotal: '总推送量',
    Log: '登录日志',
    LogToday: '当天登录数',
    UserAssociation: '管理员',
    Associated:'已关联用户',
    UnAssociated:'未关联用户'
  },
  loginStatistics: {
    LoginId: '登陆编号',
    User: '用户账号',
    OperationalSystem: '系统',
    echartsTitle: '近30日登录账户数：',
    titleName: {
      Login_id: '登录编号',
      Login_time: '登录时间',
      Email: '邮箱',
      Phone: '手机号',
      os: '系统',
      App: 'app版本',
      Location: '地址',
    }
  },
  productManage: {
    create: '创建产品',
    ManageGroup: '产品组管理',
    createDate: '上市时间',
    activateNumber: '激活量',
    productType: '产品类型',
    Release_status: '发布状态',
    Evaluate:'评价信息',
    addModel: {
      TypeID: '编号',
      title: '创建产品',
      productType: '产品型号',
      name: '产品名称',
      smDeviceType: '功能类别',
      channelNumber: '分支数量',
      sellUnitPrice: '采购单价',
      activateUnitPrice: '激活单价',
      remark: '备注',
      groupId: '产品分组',
      comMode: '连接方式',
      macQty: 'MAC数量',
      pageId: '页面编号',
      normalMode: '标准模式',
      baseType: '基础型号',
      marketDate: '上市时间',
      status: '产品状态',
      photo: '产品图片',
      photoS: '产品图片-小',
      photoM: '产品图片-中',
      photoB: '产品图片-大',
      photoSTip: '要求：200×200像素，内容居中，透明背景，大小≤500KB',
      photoMTip: '要求：400×400像素，内容居中，透明背景，大小≤500KB',
      photoBTip: '要求：800×800像素，内容居中，透明背景，大小≤500KB',
      Select_template: '选择模板',
      Templet: '模板',
      Function_Editor: '功能',
      Publish: '发布',
      aqubeCertify: 'aqube认证',
      CreateTime: '创建时间',
      share: '分享',
      newFirmware: '新固件'
    },
    validateAdd: {
      basicTypeId: '请先选择模板',
      photo: '请上传图片'
    },
    popTitle: '确定要发布吗',
    editModel: {
      title: '编辑产品',
    },
    manageModel: {
      title: '管理产品组',
      new: '创建产品组',
      Product_group: '产品分组',
      Operation: '操作',
      stitle: '创建产品组织',
      sname: '分组名称'
    },
    functionModel: {
      title: '产品功能定义',
      titleName: {
        FunctionGroup: '功能名称',
        Indentifier: '资源标识',
        IndentifierName: '标识符名称',
        Discription: '描述',
        Musted: '必选',
        Select: '选择',
        defaultValue: '默认值',
        major: '主功能'
      },
      inputPlaceholder: {
        hexstring: '定义字节长度 nBytes',
        string: '定义字节长度',
      }
    },
    evaluateModel:{
      title:'评价列表',
      information:'评价信息',
      shield:'屏蔽',
      disclosure:'公开'
  }
  },
  productPage: {
    titleName: {
      Page_id: '页面编号',
      Description: '描述',
      Photos: '图片',
      Remark: '备注',
      Date_created: '创建日期',
      View: '查看',
      Operation: '操作',
      uiCode_id: '控件编号',
      type: '类型',
    },
    addBox: {
      title: '创建页面',
      title1: '编辑页面'
    },
    mulLang: {
      addTitle: '创建词条',
      editTitle: '修改词条',
      whetherSync: '经销商词典同步更改',
      download: '语言包下载',
      downloadAll: '语言包下载全部',
      creating: '词条创建中，请勿关闭页面',
      total: '总计条数',
      valid: '有效条数',
      success: '成功',
      fail: '失败',
      tipContent: '确定创建这些词条吗？',
      importTitle: '新增导入',
      exportTitle: '导出',
      importTip: '导入 .xlsx或.xls类型的EXCEL文件',
      readS: "文件读取成功",
      readF: "文件读取出错",
      finish: '创建完成'
    },
    tip: '更改下方面页的多语言词条会改变APP上的语言标签。'
  },
  BasicProduct: {
    addParams: "新增参数",
    titleName: {
      basicName: '基础型号',
      baseNick: '产品名称',
      Id: '模板编号',
      pageId: '页面编号',
      comMode: '通信类别',
      comType: '通信方式',
      connectMode: '连网方式',
      channelNumber: '支路数量',
      macQty: 'MAC数量',
      smDeviceType: '设备类型',
      loraProductKey: 'LoRaKey',
      loraProductKeyOne: '对接产品',
      frequency: '无线频率',
      imageId: '图片',
      designImplType: '实现类型',
      basicClassId: '基础分类',
      joinSense: '场景互动',
      remark: '备注',
      whetherShare: "是否分享",
      communicateProtocol: "应用协议",
      majorKey: '主功能键',
      interactionChannel: '交互通道',
      modifyModelSync: '是否同步修改经销商机型？',
      modifyDeviceSync: '是否同步修改设备',
      deactivateModelSync: '是否停用此基础型号？',
      disabled: '停用',
      subdeviceType: '子设备类型'
    },
    comTypeBox: {
      up: '上行通信方式',
      down: '下行通信方式',
      tip: '说明:2G/3G/4G/5G都属于CELL网络',
    },
    addBox: {
      title: '创建基础型号',
      title1: '编辑基础型号',
      title2: '通用功能/参数',
    },
    basicClassBox: {
      edit: '编辑分类',
      name: '分类名称',
      title: '创建',
      title1: '编辑',
      errorInfo: '分类下有子分类，请先删除子分类'
    },
    funcBox: {
      title: '功能定义',
      add: '新增',
      import: '导入',
      sync: '同步HyECO平台数据',
      imported: '导入相同机型数据',
      importedFunc: '导入现有机型数据',
      importedExcel: '导入Excel',
      exportedExcel: '导出Excel',
      tipContent: '确定创建这些功能吗',
      sideList: {
        topSide1: '设备功能',
        topSide2: '云端功能',
        topSide3: '其他操作',
        side1: '事件',
        side2: '功能',
        side3: '参数',
        side4: '通用功能',
        side5: '通用参数',
        side8: '云端参数',
        side6: '记录',
        side7: '消息',
        side8: '操作',
      },
      titleName: {
        Order: '排序',
        Identifier: '功能标识',
        IndentyName: '功能名称',
        Discription: '功能描述',
        Value: '参数值',
        Default: '默认值',
        Bytes: '字节长度',
        stringLang: '字符串长度',
        RW: '读写权限',
        Musted: '是否必选',
        Remark: '备注',
        DeviceAction: '设备动作',
        DeviceInterface: '设备介面',
        UIcontroller: '执行控件',
        conditionalControl: '条件控件',
        DataType: '数据类型',
        ElementType: '数据类型',
        TypeDiscription: '参数描述',
        Unit: '单位',
        VIP: '增值功能',
        VIPcost: 'VIPcost',
        SenseCondition: '可当条件',
        SenseAction: '可被执行',
        SenseOperation: '计算方式',
        UpdateAsOffline: '离线更改',
        Max: '最大值',
        Min: '最小值',
        Decimals: '小数位',
        Step: '步距',
        Multiple: '倍数',
        Negative: '负数',
        'Unit-CN': '单位- 中文',
        'Unit-EN': '单位- 英文',
        LanguageKey: '语言标识',
        '0x00 wordId': '0x00 - 语言标识',
        '0x01 wordId': '0x01 - 语言标识',
        'True wordId': 'True - 语言标识',
        'False wordId': 'False - 语言标识',
        '0x00-CN': '0x00 - 中文描述',
        '0x01-CN': '0x01 - 中文描述',
        '0x00-EN': '0x00 - 英文描述',
        '0x01-EN': '0x01 - 英文描述',
        'True-CN': 'True - 中文描述',
        'False-CN': 'False - 中文描述',
        'True-EN': 'True - 英文描述',
        'False-EN': 'False - 英文描述',
        timeFormate: '显示格式',
        time: '时间单位',
        Offset: '取值偏移量',
        Len: '取值长度',
        Name: '名称',
        'Name-CN': '名称-中文',
        'Name-EN': '名称-英文',
        'ValueRange': "取值范围",
        wordEntry: '词条',
        placeholderWord: '请选择语言标识',
        Enumeration: '枚举值',
        resetSync: '是否重置设备默认值？',
      },
      titleNameLog: {
        Id: 'Id',
        Datetime: '日期',
        UpdateContents: '更新内容',
        Remark: '备注'
      },
      TypeDiscriptionPlaceholder: '请先选择数据类型',
      VerificationFailed: '验证不通过',
      selectList: {
        Numerical: '数值型',
        Enumeration: '枚举型',
        Boolean: '布尔型',
        String: '字符型',
        Datetime: '时间戳',
        HexNumerical: 'Hex数值型',
        HexEnumeration: 'Hex枚举型',
        HexBoolean: 'Hex布尔型',
        HexString: 'Hex字符型',
        HexDatetime: 'Hex时间戳',
        HexBitvalue: 'Hex位值型',
      }
    },
    adminBox: {
      title: '管理员验证',
      password: '管理员密码',
      save: '验证并操作'
    }
  },
  deviceManage: {
    topTotal1: '总计：',
    topTotal2: '近30日激活数：',
    topTotal3: ' 在线设备：',
    serialNumber: '序列号',
    macAddress: 'MAC地址',
    baseType: '基础型号',
    status: '设备状态',
    whetherOnline: '是否在线',
    Move: '移动',
    AssignedVendor:'分配安装商',
    Installer:'安装商',
    MoveLog: '移动记录',
    MoveInner: '内部移动',
    joinHome: '加入家',
    Reported: '已上报信息',
    command:'指令',
    ManageGroup: '管理组织',
    filter: '筛选列',
    export: '导出',
    print: '打印',
    Unbundling: '解绑',
    UnbundlingCont: "确定解绑吗？",
    titleName: {
      Serial_number: '序列号',
      Home_id:'家庭编号',
      MAC: 'MAC地址',
      Type: '产品型号',
      Device_group: '设备组',
      Activate: '产品状态',
      whetherOnline: '是否在线',
      Activate_time: '激活时间',
      User_account: '用户账号',
      Location: '当前地址',
      Sync_time: '同步时间',
      Last_update: '最后更新',
      Operation: '操作',
    },
    addModel: {
      title: '移动设备组',
      groupName: '设备组'
    },
    commandModel:{
      title: '指令信息',
      firmwareUpgrade:'固件升级',
      gatewayRestart:'网关重启',
      add:'发送',
      code:'指令码',
      value:'指令值'
    },
    reportModel: {
      title: '设备上报信息查询',
      tip:'请先选择需要查询的消息类别，然后点击搜索按钮进行查询',
      type:'类型',
      value:'值',
      commandKeyType:'类别',
      commandKey:'功能'
    },
    manageModel: {
      title: '管理组织',
      new: '创建组织',
      titleName: {
        ProductName: '经销商机型',
        Group_name: '组织名称',
        Remark: '备注',
        Member: '成员数量',
        Operation: '操作',
      },
      stitle: '新建组织',
      stitle1: '编辑组织',
      sname: '组名称',
      remark: '备注'
    },
    dealerModel: {
      title: '移动经销商',
      Dealer: '经销商',
      Order: '订单',
      Basic_type: '基础型号',
      noOrder: '暂无可用订单',
      titleName:{
        moveTime:'移动时间',
        previousDealerID:'原经销商',
        previousOrderID:'原订单',
        previousOrderName:'原订单名称',
        currentDealerID:'现经销商',
        currentOrderID:'现订单',
        currentOrderName:'现订单名称',
        remark:'备注',
      }
    }
  },
  userManage: {
    topTotal1: '总计：',
    topTotal2: '近30日新注册：',
    topTotal3: '当前在线用户：',
    dealerUserGroup: '用户组',
    emailAddress: '邮箱',
    phoneNumber: '手机号',
    userAccount: '用户账号',
    os: '系统',
    livenessLessThen: '活跃度<',
    livenessGreaterThen: '活跃度>',
    Move: '移动',
    ManageGroup: '管理组织',
    Block: '禁用',
    Unlock: '解禁',
    titleName: {
      Account: '账号',
      userId: '用户Id',
      userName: '用户',
      Email: '邮箱',
      Group_name: '组织名称',
      Status: '状态',
      Operational: '系统',
      App: 'app应用',
      Liveness: '活跃度',
      Registration_time: '注册时间',
      Phone: '联系电话',
      Contact_address: '联系地址',
    },
    addModel: {
      title: '移动用户组',
      groupName: '用户组'
    },
    manageModel: {
      title: '管理组织',
      new: '创建组织',
      titleName: {
        Group_name: '组织名称',
        Remark: '备注',
        Member_number: '成员数量',
        Operation: '操作',
      },
      stitle: '新建组织',
      sname: '新租',
      remark: '备注'
    },
    associate:{
      addTitle:'绑定用户',
      criteria:'搜索条件',
      userName:'管理员列表'
    },
    addUserModel:{
      title:'创建用户',
      title1:'编辑用户',
      titleName:{
        signUpOptions:'注册方式',
        countryCode:'国家码',
      },
      selectPlaceholder: {
        country:'请选择国家'
      },
    }
  },
  sideList: {
    home: '平台首页',
    Products: '产品管理',
    Pages: '产品页面',
    BasicProduct: '基础型号',
    Order: '订单管理',
    User: '用户管理',
    Login: '登录统计',
    DeviceCenter: '设备中心',
    Device: '设备管理',
    Location: '设备位置',
    firmwareCenter: '固件中心',
    firmwareVersion: '固件管理',
    firmwarePlan: '计划管理',
    firmwareDownload: '下载历史',
    AppCenter: '应用中心',
    appVersion: '版本管理',
    appPlan: '计划管理',
    appDownload: '下载历史',
    appDevice: '页面升级',
    AccountCenter: '交易中心',
    SMScost: '月度短信',
    accountRecharge: '充值管理',
    accountHistory: '交易历史',
    feedBack: '反馈信息',
    pushMessage: '推送信息',
    setting: '设置',
    templateProduct: '产品模板',
    UiController: '控件页面',
    sceneModel: '场景模型',
    Installer: '安装商管理',
    onboardingBanner:'引导页'
  },
  formRules: {
    fmtPassword: '密码格式为数字和字母，长度6到10',
    twoPassword_notMatch: '两次密码输入不匹配'
  },
  orderManage: {
    addButton: '创建订单',
    editButton: '编辑订单',
    detail: "详情",
    delete: "删除",
    Realize: '实现',
    Instance: '实例',
    titleName: {
      Order: '订单编号',
      OrderId: '订单ID',
      OrderDate: '订单日期',
      ProductId: '产品编号',
      Type: '产品型号',
      ProductName: '产品名称',
      Qty: '订单数量',
      Remark: '备注',
      Operation: '操作',
    },
    addModel: {
      title: '创建订单',
      orderId: "订单编号",
      orderDate: "订单日期",
      orderProductType: "产品型号",
      qty: "订单数量",
      remark: "备注",
      hardware: "硬件版本",
      firmware: "固件版本",
      needPublish: '请先发布产品',
      frequency: '工作频率'
    },
    detailModel: {
      title: '订单',
      serialNumber: "序列号",
      macAddress: "MAC地址",
      deviceId: '设备编号',
      mqttPassword: '设备密码',
    },
    deletModel: {
      changeTitle: '删除',
      changeCont: '确定要删除吗？这将永久的将其删除'
    }
  },
  firmwareDownload: {
    titleName: {
      id: '固件编号',
      downloadTime: '下载时间',
      serialNumber: '序列号',
      userAccount: '用户账号',
      deviceType: '设备型号',
      beforeDownVersion: '之前版本',
      afterDownVersion: '现在版本',
    }
  },
  firmwarePlan: {
    titleName: {
      id: '计划编号',
      createTime: '计划时间',
      fwareId: '固件编号',
      fwareVersion: '固件版本',
      deviceGroupName: '设备组',
      totalDevices: '设备数',
      updateDevices: '更新数',
      whetherRun: '计划状态',
      Operation: '操作',
      number: '分批数量',
      unit: '间隔单位',
      interval: '间隔时间',
      minNumber: '间隔分钟'
    },
    tip: {
      five: '上限500',
      six: '请输入1-600之间的整数'
    },
    addButton: '新建计划',
    editButton: '编辑计划',
    allGroup: '所有组',
    need: {
      fwareId: '请先添加固件'
    }
  },
  firmwareVersion: {
    start: '启动',
    stop: '暂停',
    changeTitle: '更改状态',
    changeCont: '确定更改状态吗',
    titleName: {
      id: '固件编号',
      fwareVersion: '固件版本',
      hardwareVersion: '硬件版本',
      fileName: '文件名',
      suitDeviceType: '设备型号',
      updateInformation: '更新信息',
      releaseTime: '发布日期	',
      uploadTime: '上传日期',
      remark: '备注',
      baseTypeId:'基础型号编号',
      baseType:'基础型号',
      minVer:'支持最低版本',
      maxVer:'支持最高版本',
      otherRemark:'其他说明',
    },
    addButton: '新建固件',
    addBox: {
      fileName: '包文件',
      title1: '更新信息',
      title2: '配置',
      title3: '其他',
    },
    require: {
      hardwareVersion: '请上传符合规则的包文件',
      formatError: "仅支持 BIN、ZIP、PAG类型的文件"
    }
  },
  editMesageModule: {
    title_editMessage: '编辑信息',
    lang_zh: '中文信息',
    lang_zh_ft: '中文繁体',
    lang_en: '英文信息',
    lang_fr: '法文信息',
    lang_de: '德文信息',
    lang_es: '西班牙文信息',
    lang_ja: '日文信息',
  },
  appDownload: {
    titleName: {
      id: '编号',
      downloadTime: '下载时间',
      os: '系统',
      userAccount: '用户账号',
      beforeDownVersion: '之前版本',
      afterDownVersion: '现在版本',
    }
  },
  appPlan: {
    addButton: '新建计划',
    editButton: '编辑计划',
    titleName: {
      id: '计划编号',
      canUseDate: '计划时间',
      appId: '应用编号',
      version: '版本号',
      releaseType: '发布类型',
      appStatus: 'app状态',
      os: '系统',
      deviceGroupName: '用户组',
      totalUser: '用户数',
      completeUpdateUser: '更新数',
      whetherRun: '计划状态',
      Operation: '操作'
    },
    needappId: '请先创建应用编号',
  },
  appVersion: {
    addButton: '创建app',
    Expire: '过期',
    titleName: {
      id: '应用编号',
      version: '版本号',
      releaseDate: '发布日期',
      releaseType: '发布类型',
      status: 'app状态',
      fileName: '包文件',
      updateInformation: '更新信息',
      innerLink: '内测链接',
      os: '系统'
    },
    example: '格式如1.01.1',
    deletModel: {
      changeTitle: '更改状态',
      changeCont: '确定更改状态吗'
    },
    require: {
      formatError: "仅支持 APK、IPA 类型的文件",
      formatError1: "仅支持 BIN、ZIP、PAG类型的文件"
    }
  },
  appDevice: {
    addButton: '创建版本',
    editButton: '修改版本',
    Expire: '过期',
    titleName: {
      id: '编号',
      pageId: '页面编号',
      pageVersion: '页面版本',
      appVersion: 'app版本',
      status: '状态',
      fileId: '包文件编号'
    }
  },
  account: {
    cost: {
      startMonth: '开始月份',
      endMonth: '结束月份'
    }
  },
  accountHistory: {
    titleName: {
      id: '交易编号',
      transTime: '交易时间',
      balance: '账户余额',
      transAmount: '交易金额',
      postTradeBalance: '交易后余额',
      type: '交易类型'
    }
  },
  accountSMScost: {
    titleName: {
      Month: '月份',
      smsNumber: '短信数量',
      totalAmount: '总费用'
    },
    titleName1: {
      countryNameEn: '国际名称',
      countryName: '中文名称',
      simpleCountryName: '国家代码',
      internationalCode: '区号',
      locatedContinent: '大洲',
      referencePrice: '参考价格',
      marketPrice: '市场价格',
      Operation: '操作'
    },
  },
  accountRecharge: {
    addButton: '新建充值',
    editButton: '编辑充值',
    titleName: {
      id: '交易编号',
      transTime: '交易时间',
      transAmount: '交易金额',
      type: '交易类型',
      remark: '备注'
    }
  },
  feedBack: {
    searchEmail: '用户邮箱',
    selectType: '消息状态',
    User: '用户',
    Admin: '管理员',
    detailModel: {
      title: '消息',
      reply: '回答'
    },
    titleName: {
      id: '序列号',
      latestMessageTime: '反馈时间',
      userEmail: '用户邮箱',
      phoneNumber: '用户手机号',
      statusForManager: '消息状态',
      latestMessage: '消息',
      Operation: '操作'
    }
  },
  push: {
    serialNumbers: '序列号',
    receiverGroup: '接收用户',
    addButton: '创建推送',
    titleName: {
      id: '序列号',
      pushTime: '推送时间',
      sendNumber: '推送量',
      readNumber: '阅读量',
      pushMessage: '消息内容',
      groupName: '接收用户'
    },
    addModel: {
      title: '新建消息',
      receiverGroup: '用户组',
      message: '消息内容',
      image: '图片'
    }
  },
  deviceLocation: {
    map: '地图',
    baidu: '百度地图',
    google: '谷歌地图'
  },
  setting: {
    addTitle: '创建客户',
    title: '设置资料',
    id: '公司编号',
    macMaker: 'MAC厂商编号',
    registerTime: '创建时间',
    companyName: '公司名称',
    email: '公司邮箱',
    brandName: '品牌名称',
    companyAddress: '公司地址',
    serviceTel: '服务电话',
    website: '公司网站',
    eStore: '网上商店',
    remark: '备注',
    starLevel: '星级',
    smsCharge: '短信收费',
    activateCharge: '激活收费',
    homeShow: '首页展示',
    zeroBalanceSms: '短信服务(余额<0)',
    zeroBalanceActivate: '激活服务(余额<0)',
    imageFid: '公司商标',
    imageBg: 'APP背景图',
    imageBgTip: '最多可以上传6张png或者jpg格式的图片，图片尺寸1242*2688，文件大小不超过500kb；图片文件名称要求：深色图片名称“dark_xxx”，浅色图片“light_xxx”，“xxx”部份自定义。',
    language: '语言',
    password: '接口密码',
    apiId: '接口账号',
    reset: '重置',
    resetTip: '确定重置接口密码吗？',
    emailHost: '邮箱服务商主机地址',
    emailPort: '邮箱服务商端口',
    emailAutoCode: '邮箱服务商授权码',
    weChatMiniAppid: '微信小程序ID',
    weChatMiniSecret: '微信小程序密钥',
    googleClientId:'谷歌账号ID',
    weiXinAppid:'微信开发账号',
    weiXinSecret:'微信开发账号密码',
    appleAppId:'苹果开发者账号',
    appleTeamId:'苹果后台配置 team_id',
    appleKeyId:'苹果后台配置 key_id',
    applePrivateKey:'苹果密钥',
    applePushKeyId:'苹果推送keyId',
    applePushPKey:'苹果推送私钥',
    jgAppKey:'极光推送appkey',
    jgMasteSecret:'极光推送masterSecret',
    resetPassword:'登录密码',
    resetPasswordTip:'确定重置该经销商的密码吗',
    resetPasswordTipOne:'确定重置该安装商的密码吗',
    disableTime:'app限免截止日期',
    smsApiId:'互亿无线短信验证码账号id(国外)',
    smsApiKey:'互亿无线短信验证码账号key(国外)',
    smsApiIdCN:'互亿无线短信验证码账号id(国内)',
    smsApiKeyCN:'互亿无线短信验证码账号key(国内)',
    tip: {
      websiteFormat: "英文字母+'//'+非空字符串",
      websiteExample: "例如 http://xxx.xxx.com"
    }
  },
  seceneManage: {
    titleName:{
      effectiveTime:'生效时间'
    },
    id:'序号',
    addModel: {
      title: '新建场景模型',
      title1: '编辑场景模型',
      module1: '基本信息',
      module2: '触发条件',
      module3: '执行动作',
      sceneModelName: '场景名称',
      photo: '场景图片',
      desc: '描述',
      addTrigger: '添加条件',
      addAction: '添加动作',
      triggerTip: '需要满足的条件：任意一个',
      noTrigger: '尚未设置条件',
      noAction: '尚未设置动作',
      submitTip:'规则名称不能为空，且请至少设置一个“触发条件”和一个“执行动作”',
      WeatherCondition:'天气现象',
      WindSpeed:'风力',
      WindVelocity:'风向',
      Temperature:'温度',
      Humidity:'湿度（百分比）',
      WindSpeedList:{
        selectAll:'全部',
        select1:'<=3'
      },
      WindVelocityList:{
        selectAll:'全部',
        select1:'无风',
        select2:'东',
        select3:'东南',
        select4:'东北',
        select5:'西',
        select6:'西南',
        select7:'西北',
        select8:'南',
        select9:'北',
        select10:'旋转不定',
      },
      weatherList:{
        selectAll:'全部',
        select1:'晴天',
        select2:'下雨',
        select3:'下雪',
        select4:'阴天',
      },
      triggerTypeSelList: {
        select1: '设备属性触发',
        select2: '定时触发',
        select3: '设备状态触发',
        select4: '手动点击触发',
        selectWeather: '实时天气',
      },
      intSelList: {
        select1: '=',
        select2: '>',
        select3: '<',
        select4: '指定值',
        select5: '指定范围',
      },
      timerSelList: {
        select1: '按周期定时触发',
        select2: '按策略定时触发',
        select3: '每天',
        select4: '每周',
        select5: '每月',
        select6: '每年',
        select7: '指定日期',
      },
      timerScheduleSelList: {
        select1: '周一',
        select2: '周二',
        select3: '周三',
        select4: '周四',
        select5: '周五',
        select6: '周六',
        select7: '周日',
      },
      deviceStatusList: {
        select1: '上线',
        select2: '下线',
        select3: '上下线',
      },
      selectPlaceholder: {
        baseType: '请选择基础型号',
        productType: '请选择产品型号',
        product: '请选择产品',
        service: '请选择服务',
        property: '请选择属性',
        dataTime:'请选择日期时间',
        repeat:'重复',
        interval:'间隔',
        partTime:'请选择时间段',
        onceDate:'请选择指定日期'
      },
      attempts:'次',
      seconds:'秒',
      actionTypeSelList: {
        select1: '下发命令',
        select2: '发送通知',
        select3: '上报告警',
        select4: '回复告警',
        select5: '系统功能',
        select6: '控制场景',
        select7: '智能设备',
      },
      systemFunctionList:{
        select1:'消息提醒',
      },
      delayExecution:'延迟执行',
      creatTip: '规则名称不能为空，且请至少设置一个“触发条件”和一个“执行动作”',
      editNotification:'编辑通知内容',
      selected:'默认选中',
      noBlank:"输入不能为空。",
      addtionTitle:'为整体场景添加生效限制',
      addtionTitle1:'新增附加条件',
      addtionTitle2:'删除附加条件',
      addtionBox:{
        addtion:'附加条件',
        del:'删除附加条件',
        title:'生效时间和次数',
        all:'全天生效',
        partTime:'部分时间段生效',
        timeAndRepeat:'日期与重复',
        start:'开始',
        end:'结束'
      }
    },
    tip:{
      timeRange:'请选择区间范围内的时间',
      hexColor:'请输入6位十六进制颜色值(不含#)',
    }
  },
  onboardingBanner:{
    titleName:'添加轮播图',
    titleNameEdit:'编辑轮播图',
    link:'链接',
    photoSTip:'只能上传jpg/png/jpeg文件，且不超过2MB',
    order:'排序权重',
    orderTip:'数字越大显示越靠前'
  },
  carDealers: "车商管理"
}
